import React from "react"
import { useContent } from "@thoughtbot/superglue"

import { DeveloperDocsLayout, type DeveloperDocsPage } from "@javascript/components/developer-docs/DeveloperDocsLayout"
import { BlockReferencePage } from "@javascript/components/developer-docs/BlockReferencePage"

interface Block {
  type: string
  renderer: string
  configOptions: Record<string, unknown>
}

interface BlockReferenceContent {
  pages: DeveloperDocsPage[]
  blocks: Block[]
}

export default function BlockReference() {
  const { pages, blocks } = useContent<BlockReferenceContent>()

  return (
    <DeveloperDocsLayout pages={pages} currentHref="/developers/block-reference">
      <BlockReferencePage blocks={blocks} />
    </DeveloperDocsLayout>
  )
}
